import {provideHttpClient, withInterceptorsFromDi,} from "@angular/common/http";
import {inject, NgModule, provideEnvironmentInitializer} from "@angular/core";
import {HttpLink} from "apollo-angular/http";

import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {environment} from "../environments/environment";
import {AppRoutingModule} from "./app-routing.module";
import {GraphQLModule} from "./checkout/graphql.module";
import { provideDotcomEnvironment } from './dotcom/dotcom.config';
import {CoreModule} from "./core.module";
import {AoCartModule} from "./modules/ao-cart/ao-cart.module";
import {AppComponent} from "./modules/app.component";
import {CartOverviewModule} from "./modules/cart/cart-overview/cart-overview.module";
import {CatalogModule} from "./modules/cart/catalog/catalog.module";
import {RegisterAngularLocales} from "./modules/locale/register-angular-locales";
import {OrderHistoryModule} from "./modules/orders/order-history.module";
import {ProductModule} from "./modules/product/product.module";
import {SkinAnalyzerResultsModule} from "./modules/skin-analyzer/results/skin-analyzer-results.module";
import {ShareableModule} from "./modules/social/shareable/shareable.module";
import {SurveyResultsModule} from "./modules/survey/survey-results.module";

import {provideCmsAppRouteFactory, provideCmsContentstackClient,} from "@usana/ux/cms";
import {ContentStackMarketInformedService} from "@usana/ux/cms/market-informed";

RegisterAngularLocales.registerLocales();

//This module should contain feature modules and bootstrap app component.
//Should also import AppRoutingModule which will contain all feature modules that are lazy loaded.
@NgModule({
    bootstrap: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CoreModule,
        GraphQLModule,
        AoCartModule,
        CatalogModule,
        CartOverviewModule,
        OrderHistoryModule,
        ProductModule,
        ShareableModule,
        SkinAnalyzerResultsModule,
        SurveyResultsModule,
        AppRoutingModule,
    ],
    providers: [
        provideDotcomEnvironment(),
        provideHttpClient(withInterceptorsFromDi()),
        HttpLink,
        provideCmsContentstackClient({
            apiKey: environment.contentStack.apiKey,
            deliveryToken: environment.contentStack.deliveryToken,
            environment: environment.contentStack.environment,
            region: environment.contentStack.region as
                | "US"
                | "EU"
                | "AZURE_NA"
                | "AZURE_EU"
                | "GCP_NA",
            branch: environment.contentStack.branch,
            defaultLocale: "en-us", // optional
            host: environment.contentStack.contentDelivery, // optional (CDN host)
            endpoint: environment.contentStack.endpoint,
        }),
        provideCmsAppRouteFactory(() => {
            return {
                template_marketing_pages: {
                    cmsPrefix: "/mkt",
                    appUrlBuilder: (url, locale) => {
                        return `/ux/dotcom/${locale}${url}`;
                    },
                },
            };
        }),
        provideEnvironmentInitializer(() => inject(ContentStackMarketInformedService)),
    ],
})
export class AppModule {}
